export const SET_SELECTED_CLOUD_VERTICAL = "SET_SELECTED_CLOUD_VERTICAL";
export const SET_SELECTED_STAMP_VERTICAL = "SET_SELECTED_STAMP_VERTICAL";
export const SET_SEARCH_FILTER = "SET_SEARCH_FILTER";
export const SET_PRODUCTION_ONLY_FILTER = "SET_PRODUCTION_ONLY_FILTER";
export const SET_IMMUTABLE_FILTER = "SET_IMMUTABLE_FILTER";
export const TOGGLE_COLLAPSE = "TOGGLE_COLLAPSE";
export const TOGGLE_ALL_COLLAPSE = "TOGGLE_ALL_COLLAPSE";
export const SET_CLASSIC_VIEW = "SET_CLASSIC_VIEW";
export const SET_APPLICATION_VIEW = "SET_APPLICATION_VIEW"
